import { SearchResultModel } from "./searchResultModel"

export class NavItemSearchResultModel extends SearchResultModel {
  getName() {
    return ""
  }
}
